<template>
  <v-row id="project-estimate-tab">
    <v-col
      class=""
      xl="12"
      lg="12"
    >
      <ProjectEstimates :project="project" />
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from 'vuex';

import ProjectEstimates from '@/components/projects/ProjectEstimates.vue';
import { projectRolesNames } from '@/constants/roles';

export default {
  components: { ProjectEstimates },
  props: {
    project: {
      type: Object,
      required: true,
    },
    allowedToUpdateProjectEmployee: Boolean,
  },
  data() {
    return {
      employeesByRolesWithoutTeamMembers: {},
      employeesByProjectOffices: [],
      projectRolesNames,
    };
  },
  computed: {
    ...mapGetters('auth/account', [
      'isUserAdmin',
      'isUserEmployee',
      'user',
    ]),
    ...mapGetters('shared/roles', [
      'projectRoles',
      'projectRolesMap',
    ]),
  },
  methods: {},
};
</script>
